import { cn } from 'app/lib/utils'

export function CardChip({
  icon,
  children,
  tone,
}: {
  icon: React.ReactNode
  children: React.ReactNode
  tone: `green` | `amber` | `gray`
}) {
  return (
    <span
      className={cn(
        `inline-flex max-w-full items-center gap-1 truncate rounded-md px-1.5 py-0.5 text-body-xs`,
        // oxlint-disable-next-line shadcn/no-raw-colors -- moved verbatim under the G7 parity net
        tone === `green` && `bg-green-50 text-green-800`,
        // oxlint-disable-next-line shadcn/no-raw-colors -- moved verbatim under the G7 parity net
        tone === `amber` && `bg-amber-50 text-amber-800`,
        tone === `gray` && `bg-surface-muted text-subtle`,
      )}
    >
      {icon}
      {children}
    </span>
  )
}
